import React, { useContext, useMemo } from 'react';
export var PanelTransitionStatus = React.createContext({
  mountTransitionComplete: true
});
export var usePanelTransitionStatus = function usePanelTransitionStatus() {
  return useContext(PanelTransitionStatus);
};
export var PanelTransitionStatusProvider = function PanelTransitionStatusProvider(_ref) {
  var children = _ref.children,
      _ref$mountTransitionC = _ref.mountTransitionComplete,
      mountTransitionComplete = _ref$mountTransitionC === void 0 ? true : _ref$mountTransitionC;
  var context = useMemo(function () {
    return {
      mountTransitionComplete: mountTransitionComplete
    };
  }, [mountTransitionComplete]);
  return /*#__PURE__*/React.createElement(PanelTransitionStatus.Provider, {
    value: context
  }, children);
};